<div class="modal-container hidden-scroll" [ngClass]="{ 'mobile-size': baseService.isMobile }">
  @if (!hideHeader) {
    <div class="header-modal d-flex align-items-center justify-content-between position-sticky top-0">
      <div class="title flex-fill ms-2">
        <span>
          {{ data?.translate ? (data.title | translate) : data.title }}
        </span>
      </div>
      <div class="modal-header-button d-flex flex-row m-2">
        @if (maximizeBtn) {
          <div class="rounded-circle maximize header-icon-block">
            <app-icon class="rounded-circle header-icon maximize-icon"> height </app-icon>
          </div>
        }
        @if (minimizeBtn) {
          <div class="rounded-circle minimize header-icon-block">
            <app-icon class="rounded-circle header-icon minimize-icon"> horizontal_rule </app-icon>
          </div>
        }
        <div class="header-icon-block" (click)="closeModal()">
          <app-icon class="rounded-circle header-icon close-icon"> close </app-icon>
        </div>
      </div>
    </div>
  }
  @if (!hideHeader) {
    <mat-divider></mat-divider>
  }
  <div class="body-modal text-secondary crm-scroll {{ displayCenter }}">
    <ng-template #target></ng-template>
  </div>
</div>
